// extracted by mini-css-extract-plugin
export default {"itemsList":"Pl6m_xxgLXPeg_2tFjX9","itemHeader":"vEe1VjuKJY8ffTQzzAHx","ext":"wtKIUfCTuz1oKSq4O2PB","placeHolderShimmer":"y1E12z5QTg66xSP_MQFY"};